import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export interface INewPermissionsProductsData {
  name: string;
  key: string;
  items: INewPermissionsProductsData[];
  attached: boolean;
}

export const NEW_PERMISSIONS_TOKEN = new InjectionToken<INewPermissionsService>('INewPermissionsService');

export interface INewPermissionsService {
  getData(groupId: string): Observable<INewPermissionsProductsData[]>;
  savePermissions(groupId: string, permissions: PermissionRequest): Observable<SavePermissionResponse>;
}

export interface PermissionValue {
  [key: string]: boolean;
}

export type PermissionRequest = {
  permission: string;
  enabled: boolean;
}[];

export interface PermissionResponse {
  data: {
    permissions: INewPermissionsProductsData[];
  };
}

export interface PermissionInfo {
  permissionCount: number;
  attachedPermissionCount: number;
}

export interface SavePermissionResponse {
  data: {
    title: string;
    message: string;
  }[];
}
